import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2m15.44 1.5H4.56L12 12.94zM3.5 6.56V18c0 .272.228.5.5.5h16c.272 0 .5-.228.5-.5V6.561l-7.97 7.97a.75.75 0 0 1-1.06 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }